export default __webpack_public_path__ + "static/media/icon-park_delete-five.b61e9e4b.svg";